import axios from 'axios';

// Get the API URL from environment variables or use a default
// For Create React App, we use process.env instead of import.meta.env
const isProduction = process.env.REACT_APP_ENV === 'production';

export const API_BASE_URL = isProduction 
    ? 'https://ebira.rfsteknologi.site/api/v1'
    : 'http://localhost:8000/api/v1';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add a request interceptor for JWT token
axiosInstance.interceptors.request.use(
  (config) => {
    // Skip authentication for public routes
    const isPublicRoute = config.url && (
      config.url.includes('/projects/') || 
      config.url.includes('/issues/')
    ) && window.location.pathname.startsWith('/view');
    
    if (!isPublicRoute) {
      const token = localStorage.getItem('token');
      if (token && config.headers) {
        // Use the token directly as it's already in the format "Bearer {token}"
        config.headers.Authorization = token;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't redirect to login for public routes
    const isPublicRoute = window.location.pathname.startsWith('/view');
    
    if (error.response?.status === 401 && !isPublicRoute) {
      // Handle unauthorized access
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Export isAxiosError function for error checking
export const isAxiosError = axios.isAxiosError;

export default axiosInstance;
